import LabelProvider from "core/components/label/LabelProvider";

export default LabelProvider.create({

    QLNoResults:{
        k: "quicklinks.noresults",
        v: "No Quick Links Available"
    }
});


// WEBPACK FOOTER //
// ./src/panels/quickLinks/QuickLinks.labels.ts